import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {},
    loading: false,
    error: null,
};

export const royalBridgeSlice = createSlice({
    name: "royalBridge",
    initialState,
    reducers: {
        setRoyalBridgeData: (state, action) => {
            state.data = action.payload;
        },
        setRoyalBridgeLoading: (state, action) => {
            state.loading = action.payload;
        },
        setRoyalBridgeError: (state, action) => {
            state.error = action.payload;
        },
        clearRoyalBridgeData: (state) => {
            state.data = {};
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: () => {},
});

export const {
    setRoyalBridgeData,
    setRoyalBridgeLoading,
    setRoyalBridgeError,
    clearRoyalBridgeData,
} = royalBridgeSlice.actions;

export const selectRoyalBridgeData = (state) => state.royalBridge.data;
export const selectRoyalBridgeLoading = (state) => state.royalBridge.loading;
export const selectRoyalBridgeError = (state) => state.royalBridge.error;

export default royalBridgeSlice.reducer;
